(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function trackQueries() {
		return function queriesTracker(data, config, callback) {
			var params = search.util.extend({}, config, {resultCount: data.resultCount});
			config.queryTrackedBy = this.processor.track('searchQuery', params);
			callback();
		};
	}

	function trackNoResults() {
		// Tracks a query that returned no results
		// Add before spellchecking handling so we only get the no-results cases that are displayed to the user
		return function noResultsTracker(data, config, callback) {
			// Do nothing if results were found
			if(data.resultCount) {
				return callback();
			}

			var params = search.util.extend({}, config, {resultCount: 0});
			config.noResultsTrackedBy = this.processor.track('noResults', params);
			callback();
		};
	}

	function setUp(processor) {
		processor.usePost(trackQueries(), 1000);
		processor.usePost(trackNoResults(), 1000);
	}

	var plugins = search.plugins = search.plugins || {};
	var tracking = plugins.tracking = plugins.tracking || {};

	tracking.trackQueries = trackQueries;
	tracking.trackNoResults = trackNoResults;
	tracking.setUp = setUp;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/tracking.js
// module id = 303
// module chunks = 0